import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'
import GlobalStore from '@/store/modules/global'
import { BASE_PATH_APP } from '@/commons/config'

import errorRouter from './error'
import homeRouter from './home'
import aboutRouter from './about'
import authRouter from './auth'

Vue.use(Router)

const routes: RouteConfig[] = [
  ...homeRouter,
  ...aboutRouter,
  ...authRouter,
  ...errorRouter,
]

export const router = new Router({
  base: BASE_PATH_APP,
  routes
})

router.beforeEach((to, from, next) => {
  const { authorize } = to.meta
  const currentUser = GlobalStore.user

  if (authorize) {
    if (!currentUser) {
      return next({ name: 'login', query: { returnUrl: to.path } })
    }

    if (authorize.length && !GlobalStore.functionalities.some(f => authorize.includes(f))) {
      return next({ name: 'denied' })
    }
  }

  next()
})
